import { HttpClientModule } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { initializeAppCheck, provideAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { firebaseConfig } from '../../../src/firebase.config';
import { firebaseTestConfig } from '../../../src/firebase.test.config';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
   providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes),
      importProvidersFrom(HttpClientModule, BrowserAnimationsModule),
      importProvidersFrom(TranslateModule.forRoot()),
      provideFirebaseApp(() => initializeApp(environment.testMode ? firebaseTestConfig : firebaseConfig)),
      provideAuth(() => getAuth()),
      provideAppCheck(() => {
         const cfg = environment.testMode ? firebaseTestConfig : firebaseConfig;
         if (!cfg.recaptchaSiteKey) {
            throw new Error('recaptchaSiteKey is not configured for the current Firebase project');
         }
         return initializeAppCheck(getApp(), {
            provider: new ReCaptchaEnterpriseProvider(cfg.recaptchaSiteKey),
            isTokenAutoRefreshEnabled: true,
         });
      }),
   ],
};
